import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMerchantRelatedBonus, fetchBonus } from 'core/actions/bonus';
import { selectUserIsIdentified } from 'core/selectors/user';
import {
  selectBonusOffersConfig,
  selectBonusOffersIsLoading,
  selectBonusOffersIsLoaded,
  selectBonusOffersPlacement,
  selectBonusOffersNotQualifiedAndActiveFormatted,
  selectBonusTrackerOffer,
  selectBonusButtonOffer,
  selectBonusRollingOffersToShow,
  selectBonusPublicAutomaticOffersToShow,
  selectBonusRollingOfferToShow,
  selectBonusRollingAndPublicAutomaticOffersToShow,
  selectBonusButtonPopup,
  selectBonusButtonModal,
} from '../selectors';

/*
 There are multiple places where we  use `useGetBonusOffers` hook and it appears there is a race condition
 when `isLoaded` and `isLoading` flags in redux state are updated with a delay so the following
`useGetBonusOffers` hooks could start fetching data again leading to multiple API calls.
This is a temporal fix and we should return to resolving this issue after completing updating our libs.
*/
let isFetchingProceeded = false;

export const useGetBonusOffers = (ignoreFetching) => {
  const dispatch = useDispatch();
  const config = useSelector(selectBonusOffersConfig);
  const isLoading = useSelector(selectBonusOffersIsLoading);
  const isLoaded = useSelector(selectBonusOffersIsLoaded);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const bonusOffers = useSelector(selectBonusOffersPlacement);
  const bonusOffersNotQualifiedAndActiveFormatted = useSelector(selectBonusOffersNotQualifiedAndActiveFormatted);
  const bonusTrackerOffer = useSelector(selectBonusTrackerOffer);
  const bonusButtonOffer = useSelector(selectBonusButtonOffer);
  const bonusRollingOffersToShow = useSelector(selectBonusRollingOffersToShow);
  const publicAutomaticOffersToShow = useSelector(selectBonusPublicAutomaticOffersToShow);
  const bonusRollingOfferToShow = useSelector(selectBonusRollingOfferToShow);
  const bonusRollingAndPublicAutomaticOffersToShow = useSelector(selectBonusRollingAndPublicAutomaticOffersToShow);
  const bonusButtonPopup = useSelector(selectBonusButtonPopup);
  const bonusButtonModal = useSelector(selectBonusButtonModal);

  useEffect(() => {
    if (!isLoading && !isLoaded && !isFetchingProceeded && !ignoreFetching) {
      const { api: { params, options } } = config;
      if (userIsIdentified) {
        dispatch(fetchMerchantRelatedBonus(params, options));
      } else {
        dispatch(fetchBonus(params, options));
      }

      isFetchingProceeded = true;
    }
  }, [isLoaded, isLoading]);

  return {
    isLoaded,
    isLoading,
    bonusOffers,
    bonusOffersNotQualifiedAndActiveFormatted,
    bonusTrackerOffer,
    bonusRollingOffersToShow,
    bonusRollingOfferToShow,
    publicAutomaticOffersToShow,
    bonusRollingAndPublicAutomaticOffersToShow,
    bonusButtonOffer,
    bonusButtonPopup,
    bonusButtonModal,
  };
};
